export interface IDashboardInputModel {
    ic?: number
    from_Date?: number
    to_Date?: number
}


export interface IDashboardOutputModel {
    projectCount: number
    activeMembers: number
    totalDrawings: number
    twoDrawings: number
    threeDrawings: number
}

export interface IICInputModel {
    ic_Code?: number
}

export interface IFlexDCIInputModel {
    projectId: number
    groupId: number
}

export interface IManHourInputModel {
    projectId: number
    groupId?: number
}

export interface IICOutputModel {
    ic_Code: number
    ic_Description: string
    ic_Short_Description: string
}

export interface IProjectDashboardInputModel {
    project_Id?: number
    member_Id: number
}

export interface IProjectDashboardOutputModel {
    activeProjects: number
    totalRepositoryDocuments: number
    myRepositoryDocuments: number
    sharedRepositoryDocuments: number
    totalScheduleDocuments: number
    myScheduleDocuments: number
    wfYetToStartDocuments: number
    wfActionPendingDocuments: number
    wfActionTakenDocuments: number
    communicationInbox: number
    communicationSent: number
}

export interface IProjectDocDashboardOutputModel {
    doc_Count: number
    status: string
    color: string
}

export interface IDashboardProjOutputModel {
    totalDays: number
    completedDays: number
    remainingDays: number
    plannedDocuments: number
    completedDocuments: number
    balanceDocuments: number
    plannedManHours: number
    actualManHours: number
    balanceManHours: number
}

export interface IProjectDocDashboardInputModel {
    project_Id?: number
    member_Id: number
    trans_Type: string
}

export interface IProjDashboardInputModel {
    project_Id: number
}

export interface IProjDocDashboardInputModel {
    project_Id: number
    trans_Type: string
}

export interface IProjDocDashboardOutputModel {
    doc_Count: number
    status: string
    color: string
    doc_Percentage: string
}

export interface IGFCDrawingInputModel {
    project_Id?: number
    stage_Id?: number
}

export interface IGFCDrawingOutputModel {
    doc_Count: number[]
    status: string
    category: string[]
}

export interface IDCIAdherenceOutputModel {
    delay_Reason: string
    doc_Count: number
    total_Doc_Count: number
    color: string
    doc_Percentage: string
}

export interface IStageRevOutputModel {
    status: string
    doc_Count: number
    color: string
}

export interface IStageDetailsOutputModel {
    stages: string[]
    doc_Count: number[]
    status: string
}

export interface IJobMHOutputModel {
    actual_Manhour: number
    status: string
}

export interface IJobMHInputModel {
    project_Code: string
}

export interface IHomeDashboardInputModel {
    tran_Type: string
    companyCode?: number
    clusterData?: string
    jsonJobCode?: string
    userId: number
    isLatestRevision: boolean
    iCId?: string|null
    projectId?: string|null
    groupId?: string|null
    disciplineId?: string|null 
    isSuperUser: boolean
}

